export function SetupTabs() {
    const Els = document.querySelectorAll('.c-tabs')

    if (Els.length) {
        import('./tabs')
            .then((m) => m.Tabs)
            .then((Tabs) => {
                Tabs(Els)
            })
    }
}
